function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    if (!this.input) return;
    this.changeEvent = new Event('change', { bubbles: true });

    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');
    this.boundOnKeyUp = this.onKeyUp.bind(this);
    this.boundOnFocusOut = this.onFocusOut.bind(this);
    this.boundOnSummaryClick = this.onSummaryClick.bind(this);
    this.boundOnCloseButtonClick = this.onCloseButtonClick.bind(this);

    this.addEventListener('keyup', this.boundOnKeyUp);
    this.addEventListener('focusout', this.boundOnFocusOut);
    this.bindEvents();
  }

  disconnectedCallback() {
    this.removeEventListener('keyup', this.boundOnKeyUp);
    this.removeEventListener('focusout', this.boundOnFocusOut);
    this.querySelectorAll('summary').forEach(summary => summary.removeEventListener('click', this.boundOnSummaryClick));
    this.querySelectorAll('button').forEach(button => button.removeEventListener('click', this.boundOnCloseButtonClick));
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.boundOnSummaryClick));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.boundOnCloseButtonClick));
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)').matches) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.boundHide = this.hide.bind(this, false);
    this.boundOnKeyUp = (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    };
    this.boundOnClick = (event) => {
      const target = event.target;
      // Close if clicking directly on modal, dialog background, or content padding
      if (target === this ||
        target.classList.contains('product-media-modal__dialog') ||
        target.classList.contains('product-media-modal__content') ||
        target.classList.contains('product-popup-modal__content-info') ||
        target.classList.contains('quick-add-modal')) {
        this.hide();
      }
    };

    const closeBtn = this.querySelector('[id^="ModalClose-"]');
    if (closeBtn) {
      closeBtn.addEventListener('click', this.boundHide);
    }
    this.addEventListener('keyup', this.boundOnKeyUp);
    this.addEventListener('click', this.boundOnClick);
  }

  connectedCallback() {
    if (this.moved) {
      // Re-attach all listeners after element was moved to body
      const closeBtn = this.querySelector('[id^="ModalClose-"]');
      if (closeBtn) {
        closeBtn.addEventListener('click', this.boundHide);
      }
      this.addEventListener('keyup', this.boundOnKeyUp);
      this.addEventListener('click', this.boundOnClick);
      return;
    }
    this.moved = true;
    document.body.appendChild(this);
  }

  disconnectedCallback() {
    const closeBtn = this.querySelector('[id^="ModalClose-"]');
    if (closeBtn) closeBtn.removeEventListener('click', this.boundHide);
    this.removeEventListener('keyup', this.boundOnKeyUp);
    this.removeEventListener('click', this.boundOnClick);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  connectedCallback() {
    // Auto-play när synlig i viewport
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.loadContent(false);
        } else {
          this.pauseContent();
        }
      });
    }, { rootMargin: '50px', threshold: 0.25 });
    this.observer.observe(this);
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      this.classList.add('deferred-media--loading');

      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));

      // Hantera laddning och ta bort spinner
      if (deferredElement.tagName === 'VIDEO') {
        // Kritiskt för Safari iOS - säkerställ alla attribut för inline-uppspelning
        deferredElement.muted = true;
        deferredElement.setAttribute('muted', '');
        deferredElement.setAttribute('playsinline', '');
        deferredElement.setAttribute('webkit-playsinline', '');
        deferredElement.playsInline = true;

        deferredElement.addEventListener('canplay', () => {
          this.classList.remove('deferred-media--loading');
          // Använd Promise-baserad play() med fallback för Safari iOS
          const playPromise = deferredElement.play();
          if (playPromise !== undefined) {
            playPromise.catch((error) => {
              // Autoplay blockerades - vanligt på iOS utan användarinteraktion
              console.log('Video autoplay prevented:', error);
            });
          }
        }, { once: true });

        // Fallback: om canplay aldrig triggras, ta bort spinner efter timeout
        setTimeout(() => {
          if (this.classList.contains('deferred-media--loading')) {
            this.classList.remove('deferred-media--loading');
          }
        }, 3000);
      } else if (deferredElement.tagName === 'IFRAME') {
        deferredElement.addEventListener('load', () => {
          this.classList.remove('deferred-media--loading');
        }, { once: true });
      } else {
        this.classList.remove('deferred-media--loading');
      }

      if (focus) deferredElement.focus();
    } else {
      // Content already loaded, just play it
      const video = this.querySelector('video');
      if (video) {
        video.muted = true;
        video.setAttribute('muted', '');
        video.playsInline = true;
        const playPromise = video.play();
        if (playPromise !== undefined) {
          playPromise.catch((error) => {
            console.log('Video replay prevented:', error);
          });
        }
      }
    }
  }

  pauseContent() {
    const video = this.querySelector('video');
    if (video) video.pause();

    // Pausa YouTube/Vimeo iframes
    const iframe = this.querySelector('iframe');
    if (iframe) {
      if (iframe.classList.contains('js-youtube')) {
        iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
      } else if (iframe.classList.contains('js-vimeo')) {
        iframe.contentWindow.postMessage('{"method":"pause"}', '*');
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    this.resizeObserver = new ResizeObserver(entries => this.initPages());
    this.resizeObserver.observe(this.slider);

    this.boundUpdate = this.update.bind(this);
    this.boundOnButtonClick = this.onButtonClick.bind(this);

    this.slider.addEventListener('scroll', this.boundUpdate);
    this.prevButton.addEventListener('click', this.boundOnButtonClick);
    this.nextButton.addEventListener('click', this.boundOnButtonClick);
  }

  disconnectedCallback() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
    if (this.slider) {
      this.slider.removeEventListener('scroll', this.boundUpdate);
    }
    if (this.prevButton) {
      this.prevButton.removeEventListener('click', this.boundOnButtonClick);
    }
    if (this.nextButton) {
      this.nextButton.removeEventListener('click', this.boundOnButtonClick);
    }
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', {
        detail: {
          currentPage: this.currentPage,
          currentElement: this.sliderItemsToShow[this.currentPage - 1]
        }
      }));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.boundLinkToSlide = this.linkToSlide.bind(this);
    this.boundSetSlideVisibility = this.setSlideVisibility.bind(this);

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.boundLinkToSlide));
    this.slider.addEventListener('scroll', this.boundSetSlideVisibility);
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    // Clear autoplay interval to prevent memory leaks
    if (this.autoplay) {
      clearInterval(this.autoplay);
    }
    // Remove event listeners
    if (this.sliderControlLinksArray) {
      this.sliderControlLinksArray.forEach(link => link.removeEventListener('click', this.boundLinkToSlide));
    }
    if (this.slider) {
      this.slider.removeEventListener('scroll', this.boundSetSlideVisibility);
    }
    // Remove autoplay button listeners
    if (this.sliderAutoplayButton) {
      this.sliderAutoplayButton.removeEventListener('click', this.boundAutoPlayToggle);
    }
    this.removeEventListener('mouseover', this.boundFocusInHandling);
    this.removeEventListener('mouseleave', this.boundFocusOutHandling);
    this.removeEventListener('focusin', this.boundFocusInHandling);
    this.removeEventListener('focusout', this.boundFocusOutHandling);
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.boundAutoPlayToggle = this.autoPlayToggle.bind(this);
    this.boundFocusInHandling = this.focusInHandling.bind(this);
    this.boundFocusOutHandling = this.focusOutHandling.bind(this);

    this.sliderAutoplayButton.addEventListener('click', this.boundAutoPlayToggle);
    this.addEventListener('mouseover', this.boundFocusInHandling);
    this.addEventListener('mouseleave', this.boundFocusOutHandling);
    this.addEventListener('focusin', this.boundFocusInHandling);
    this.addEventListener('focusout', this.boundFocusOutHandling);

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length) linkElements.forEach(button => {
          button.removeAttribute('tabindex');
        });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length) linkElements.forEach(button => {
          button.setAttribute('tabindex', '-1');
        });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    this.abortController = null;
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach(mediaGallery => mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true));

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    if (newMediaModal) modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(variant => this.querySelector(':checked').value === variant.option1);
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants.filter(variant => variant.available && variant[`option${index}`] === previousOptionSelected).map(variantOption => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue)
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    // Abort any previous pending request
    if (this.abortController) {
      this.abortController.abort();
    }
    this.abortController = new AbortController();

    fetch(`${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`, { signal: this.abortController.signal })
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const skuSource = html.getElementById(`Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(`Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        // Store availability element for pickup info
        const storeAvailabilitySource = html.getElementById(`StoreAvailability-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const storeAvailabilityDestination = document.getElementById(`StoreAvailability-${this.dataset.section}`);

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
        }

        // Update store availability data attributes and display from fetched HTML
        if (storeAvailabilitySource && storeAvailabilityDestination) {
          // Copy data attributes from source (contains updated inventory for new variant)
          storeAvailabilityDestination.dataset.inventoryQuantity = storeAvailabilitySource.dataset.inventoryQuantity;
          storeAvailabilityDestination.dataset.inventoryManagement = storeAvailabilitySource.dataset.inventoryManagement;
          // Copy display style and class
          storeAvailabilityDestination.style.display = storeAvailabilitySource.style.display;
          storeAvailabilityDestination.className = storeAvailabilitySource.className;
          // Copy inner HTML (message)
          storeAvailabilityDestination.innerHTML = storeAvailabilitySource.innerHTML;

          // Directly update pickup time if enabled and product is in stock
          const inventoryQty = parseInt(storeAvailabilitySource.dataset.inventoryQuantity) || 0;
          if (storeAvailabilityDestination.dataset.enableDynamicPickupTime === 'true' && inventoryQty > 0) {
            if (typeof window.PickupTimeCalculator !== 'undefined' && typeof window.opening_hours_data !== 'undefined') {
              window.PickupTimeCalculator.update(storeAvailabilityDestination, window.opening_hours_data, {
                enableDynamicPickupTime: true,
                pickupOpenText: storeAvailabilityDestination.dataset.pickupOpenText,
                pickupClosedText: storeAvailabilityDestination.dataset.pickupClosedText
              });
            } else {
              // Fallback to static message if calculator not available
              const inStockText = storeAvailabilityDestination.dataset.inStockText || 'Finns i butik - kan hämtas samma dag';
              const messageSpan = storeAvailabilityDestination.querySelector('span');
              if (messageSpan) {
                messageSpan.textContent = inStockText;
              }
            }
          }
        }

        // Update product dimensions block from fetched HTML
        const dimensionsDestination = document.getElementById(`ProductDimensions-${this.dataset.section}`);
        const dimensionsSource = html.getElementById(`ProductDimensions-${sectionId}`);
        if (dimensionsDestination) {
          if (dimensionsSource) {
            dimensionsDestination.innerHTML = dimensionsSource.innerHTML;
            dimensionsDestination.style.display = '';
            // Re-run the 3D SVG illustration script for the new dimensions
            const illustrationEl = dimensionsDestination.querySelector('.product-dimensions__illustration');
            if (illustrationEl) {
              const W = parseFloat(illustrationEl.dataset.w) || 100;
              const D = parseFloat(illustrationEl.dataset.d) || 100;
              const H = parseFloat(illustrationEl.dataset.h) || 100;
              const unit = illustrationEl.dataset.unit || 'cm';
              const svg = illustrationEl.querySelector('svg');
              if (svg) {
                svg.innerHTML = '';
                const maxDim = Math.max(W, D, H);
                const scale = 90 / maxDim;
                const nw = Math.max(W * scale, 18);
                const nd = Math.max(D * scale, 18);
                const nh = Math.max(H * scale, 18);
                const cx = 140, baseY = 175;
                const ax = 0.866, ay = 0.5;
                const fbl = [cx - nw*ax, baseY - nw*ay];
                const fbr = [cx, baseY];
                const bbl = [cx - nw*ax + nd*ax, baseY - nw*ay - nd*ay];
                const bbr = [cx + nd*ax, baseY - nd*ay];
                const ftl = [fbl[0], fbl[1] - nh];
                const ftr = [fbr[0], fbr[1] - nh];
                const btl = [bbl[0], bbl[1] - nh];
                const btr = [bbr[0], bbr[1] - nh];
                function pts(arr){ return arr.map(function(p){return p[0].toFixed(1)+','+p[1].toFixed(1)}).join(' '); }
                function mid(a,b){ return [(a[0]+b[0])/2,(a[1]+b[1])/2]; }
                const ns = 'http://www.w3.org/2000/svg';
                function mkEl(tag,attrs){ const e=document.createElementNS(ns,tag); for(const k in attrs) e.setAttribute(k,attrs[k]); return e; }
                svg.appendChild(mkEl('polygon',{'class':'dim-face dim-face--top',points:pts([ftl,btl,btr,ftr])}));
                svg.appendChild(mkEl('polygon',{'class':'dim-face dim-face--front',points:pts([fbl,fbr,ftr,ftl])}));
                svg.appendChild(mkEl('polygon',{'class':'dim-face dim-face--side',points:pts([fbr,bbr,btr,ftr])}));
                const edges = [[fbl,fbr],[fbr,ftr],[ftr,ftl],[ftl,fbl],[fbr,bbr],[bbr,btr],[btr,btl],[btl,ftl],[btr,ftr]];
                edges.forEach(function(e){ svg.appendChild(mkEl('line',{'class':'dim-edge',x1:e[0][0],y1:e[0][1],x2:e[1][0],y2:e[1][1]})); });
                const tickLen = 12, gap = 6;
                const wOff = 18;
                const w1 = [fbl[0], fbl[1]+wOff], w2 = [fbr[0], fbr[1]+wOff];
                svg.appendChild(mkEl('line',{'class':'dim-line dim-line--tick',x1:fbl[0],y1:fbl[1]+gap,x2:w1[0],y2:w1[1]+4}));
                svg.appendChild(mkEl('line',{'class':'dim-line dim-line--tick',x1:fbr[0],y1:fbr[1]+gap,x2:w2[0],y2:w2[1]+4}));
                svg.appendChild(mkEl('line',{'class':'dim-line',x1:w1[0],y1:w1[1],x2:w2[0],y2:w2[1],'stroke-dasharray':'4 3'}));
                const wMid = mid(w1,w2);
                const wAngle = Math.atan2(w2[1]-w1[1],w2[0]-w1[0])*180/Math.PI;
                const wText = mkEl('text',{'class':'dim-text dim-text--lg',x:wMid[0],y:wMid[1],'text-anchor':'middle','dominant-baseline':'central',transform:'rotate('+wAngle.toFixed(1)+','+wMid[0].toFixed(1)+','+wMid[1].toFixed(1)+')',dy:'-7'});
                wText.textContent = W + ' ' + unit;
                svg.appendChild(wText);
                const d1 = [fbr[0]+wOff*0.5, fbr[1]+wOff*0.28], d2 = [bbr[0]+wOff*0.5, bbr[1]+wOff*0.28];
                svg.appendChild(mkEl('line',{'class':'dim-line dim-line--tick',x1:fbr[0]+gap*0.4,y1:fbr[1]+gap*0.2,x2:d1[0]+3,y2:d1[1]+2}));
                svg.appendChild(mkEl('line',{'class':'dim-line dim-line--tick',x1:bbr[0]+gap*0.4,y1:bbr[1]+gap*0.2,x2:d2[0]+3,y2:d2[1]+2}));
                svg.appendChild(mkEl('line',{'class':'dim-line',x1:d1[0],y1:d1[1],x2:d2[0],y2:d2[1],'stroke-dasharray':'4 3'}));
                const dMid = mid(d1,d2);
                const dAngle = Math.atan2(d2[1]-d1[1],d2[0]-d1[0])*180/Math.PI;
                const dText = mkEl('text',{'class':'dim-text dim-text--lg',x:dMid[0],y:dMid[1],'text-anchor':'middle','dominant-baseline':'central',transform:'rotate('+dAngle.toFixed(1)+','+dMid[0].toFixed(1)+','+dMid[1].toFixed(1)+')',dy:'-7'});
                dText.textContent = D + ' ' + unit;
                svg.appendChild(dText);
                const hOff = 20;
                const h1 = [fbl[0]-hOff, fbl[1]], h2 = [ftl[0]-hOff, ftl[1]];
                svg.appendChild(mkEl('line',{'class':'dim-line dim-line--tick',x1:fbl[0]-gap,y1:fbl[1],x2:h1[0]-4,y2:h1[1]}));
                svg.appendChild(mkEl('line',{'class':'dim-line dim-line--tick',x1:ftl[0]-gap,y1:ftl[1],x2:h2[0]-4,y2:h2[1]}));
                svg.appendChild(mkEl('line',{'class':'dim-line',x1:h1[0],y1:h1[1],x2:h2[0],y2:h2[1],'stroke-dasharray':'4 3'}));
                const hMid = mid(h1,h2);
                const hText = mkEl('text',{'class':'dim-text dim-text--lg',x:hMid[0],y:hMid[1],'text-anchor':'middle','dominant-baseline':'central',transform:'rotate(-90,'+hMid[0].toFixed(1)+','+hMid[1].toFixed(1)+')',dy:'-8'});
                hText.textContent = H + ' ' + unit;
                svg.appendChild(hText);
              }
            }
          } else {
            // New variant has no dimensions – hide the block
            dimensionsDestination.style.display = 'none';
          }
        }

        // Update packaging info block from fetched HTML
        const packageInfoDestination = document.getElementById(`PackageInfo-${this.dataset.section}`);
        const packageInfoSource = html.getElementById(`PackageInfo-${sectionId}`);
        if (packageInfoDestination && packageInfoSource) {
          // Replace the packaging sub-section and all sibling items after it
          const parentGrid = packageInfoDestination.closest('.info-grid');
          const sourceGrid = packageInfoSource.closest('.info-grid');
          if (parentGrid && sourceGrid) {
            // Remove all existing package items (from PackageInfo onward)
            const existingPkgItems = [];
            let node = packageInfoDestination;
            while (node) {
              existingPkgItems.push(node);
              node = node.nextElementSibling;
            }
            // Get source package items
            const sourcePkgNode = sourceGrid.querySelector(`#PackageInfo-${sectionId}`);
            if (sourcePkgNode) {
              const newItems = [];
              let sNode = sourcePkgNode;
              while (sNode) {
                newItems.push(sNode.cloneNode(true));
                sNode = sNode.nextElementSibling;
              }
              existingPkgItems.forEach(el => el.remove());
              newItems.forEach(el => parentGrid.appendChild(el));
            }
          }
        }

        // Update weight in info accordion from fetched HTML
        const weightDestination = document.getElementById(`Weight-accordion-${this.dataset.section}`);
        const weightSource = html.getElementById(`Weight-accordion-${sectionId}`);
        if (weightDestination && weightSource) {
          weightDestination.innerHTML = weightSource.innerHTML;
        } else if (weightDestination && !weightSource) {
          weightDestination.style.display = 'none';
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');

        if (inventoryDestination && inventorySource) inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true, window.variantStrings.soldOut);

        // Extract inventory_quantity from store availability element for event
        let inventoryQuantity = null;
        if (storeAvailabilitySource) {
          inventoryQuantity = parseInt(storeAvailabilitySource.dataset.inventoryQuantity) || 0;
        }

        // Create enriched variant with inventory_quantity
        const enrichedVariant = {
          ...this.currentVariant,
          inventory_quantity: inventoryQuantity
        };

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: enrichedVariant
          }
        });
      })
      .catch((error) => {
        if (error.name === 'AbortError') {
          // Request was aborted, ignore
          return;
        }
        console.error('Failed to render product info:', error);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
    if (inventory) inventory.classList.add('visibility-hidden');
    if (sku) sku.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch((error) => {
          console.error('Failed to load product recommendations:', error);
        });
    }

    this.intersectionObserver = new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' });
    this.intersectionObserver.observe(this);
  }

  disconnectedCallback() {
    if (this.intersectionObserver) {
      this.intersectionObserver.disconnect();
    }
  }
}

customElements.define('product-recommendations', ProductRecommendations);

// Fade out videos right before they loop to make playback smoother
document.addEventListener('timeupdate', function (e) {
  if (e.target && e.target.tagName === 'VIDEO' && e.target.classList.contains('fade-loop')) {
    const video = e.target;
    // Ensure video is set to loop natively
    if (!video.loop) video.loop = true;

    // Fade out slightly ~0.4s before the video ends
    if (video.duration && video.currentTime >= video.duration - 0.4) {
      if (video.style.opacity !== '0') {
        video.style.opacity = '0';
        video.style.transition = 'opacity 0.4s ease';
      }
    } else if (video.currentTime < 1.0 && video.style.opacity === '0') {
      // Fade back in quickly when video restarts
      video.style.opacity = '1';
    }
  }
}, true);

// Pause/Play button for product videos
if (!document.getElementById('video-controls-style')) {
  const style = document.createElement('style');
  style.id = 'video-controls-style';
  style.innerHTML = `
    .video-pause-btn {
      position: absolute !important;
      bottom: 15px !important;
      left: 15px !important;
      top: auto !important;
      right: auto !important;
      width: max-content !important;
      height: auto !important;
      max-height: none !important;
      min-height: 0 !important;
      z-index: 10;
      background: rgba(255, 255, 255, 0.95);
      border: 1px solid rgba(0, 0, 0, 0.25);
      border-radius: 20px !important;
      padding: 5px 12px !important;
      font-size: 11px;
      letter-spacing: 0.05em;
      text-transform: uppercase;
      font-weight: 500;
      color: #000;
      cursor: pointer;
      display: flex !important;
      align-items: center;
      justify-content: center;
      gap: 6px;
      transition: all 0.2s ease;
      font-family: inherit;
      box-shadow: 0 2px 6px rgba(0,0,0,0.06);
    }
    .video-pause-btn:hover {
      background: #fff;
      transform: scale(1.05);
    }
    .video-pause-btn svg {
      width: 8px;
      height: 8px;
      fill: currentColor;
    }
    .video-pause-btn.paused {
      background: rgba(0, 0, 0, 0.75);
      color: #fff;
      border-color: rgba(255, 255, 255, 0.2);
    }
  `;
  document.head.appendChild(style);
}

const pauseIcon = `<svg viewBox="0 0 10 10"><rect x="2" y="1" width="2" height="8" /><rect x="6" y="1" width="2" height="8" /></svg>`;
const playIcon = `<svg viewBox="0 0 10 10"><polygon points="2,1 9,5 2,9" /></svg>`;

document.addEventListener('play', function (e) {
  if (e.target && e.target.tagName === 'VIDEO' && e.target.closest('deferred-media, .product-media-modal__model, .global-media-settings')) {
    const video = e.target;
    const parent = video.parentElement;

    if (getComputedStyle(parent).position === 'static') {
      parent.style.position = 'relative';
    }

    if (!parent.querySelector('.video-pause-btn') && !video.closest('.video-pause-btn')) {
      const btn = document.createElement('button');
      btn.className = 'video-pause-btn';
      btn.innerHTML = pauseIcon + '<span>Paus</span>';
      parent.appendChild(btn);

      btn.addEventListener('click', (ev) => {
        ev.preventDefault();
        ev.stopPropagation();
        if (video.paused) {
          video.play();
        } else {
          video.pause();
        }
      });
      video.addEventListener('pause', () => {
        btn.classList.add('paused');
        btn.innerHTML = playIcon + '<span>Spela</span>';
      });
      video.addEventListener('play', () => {
        btn.classList.remove('paused');
        btn.innerHTML = pauseIcon + '<span>Paus</span>';
      });

      // Add click to zoom on video itself (if not clicked on the pause btn)
      video.style.cursor = 'zoom-in';
      video.addEventListener('click', (ev) => {
        // Prevent if they clicked a control or the modal itself
        if (ev.target.closest('.video-pause-btn') || document.querySelector('product-modal[open]')) return;

        // Find the hidden modal opener for this specific video
        const container = video.closest('.product__media-item, .product__media-gallery');
        if (container) {
          const openerBtn = container.querySelector('.video-expand-btn-hidden');
          if (openerBtn) {
            openerBtn.click();
          }
        }
      });
    }
  }
}, true);
